/**
 * Inside the back office frame, tell the host page which deck is open so its own address follows (a shareable
 * /agents/omni/reports?edit=<id> link, live E2E 2026-10-20). Only these deep-link keys travel; never the token,
 * the scope or the embed flags. The host mirrors them with history.replaceState, so the frame is not rebuilt.
 */
import { useEffect } from 'react';

export const HOST_LINK_KEYS = ['edit', 'new', 'plan'] as const;

/** The deep-link part of a query string, as plain pairs. */
export function hostLinkParams(search: URLSearchParams): Record<string, string> {
  const out: Record<string, string> = {};
  for (const k of HOST_LINK_KEYS) { const v = search.get(k); if (v) out[k] = v; }
  return out;
}

/** The host's origin when this page runs in a frame (from the referrer), else null. */
function hostOrigin(): string | null {
  if (typeof window === 'undefined' || window.parent === window) return null;
  try { return document.referrer ? new URL(document.referrer).origin : null; } catch { return null; }
}

export function useHostLocationSync(search: URLSearchParams): void {
  const key = JSON.stringify(hostLinkParams(search));
  useEffect(() => {
    const origin = hostOrigin(); if (!origin) return;
    try { window.parent.postMessage({ type: 'omni:location', params: JSON.parse(key) }, origin); } catch { /* host gone */ }
  }, [key]);
}
